export const CONNECTION = {
  status: "connected",
  companyName: "CAT Traders Demo LLC",
  realmId: "9341451845901234",
  connectedAt: "2026-10-10",
  lastSyncAt: "2026-10-14 09:42 AM",
};

export const ACCOUNT_MAPPINGS = [
  {
    id: 1,
    catSource: "Cost Sheet — Amount Paid",
    qbAccount: "Inventory Asset",
    qbAccountType: "Other Current Asset",
    side: "Debit",
  },
  {
    id: 2,
    catSource: "Cost Sheet — Payment (Cash / Check / Bank)",
    qbAccount: "Operating Bank Account",
    qbAccountType: "Bank",
    side: "Credit",
  },
  {
    id: 3,
    catSource: "Settlement — Metal Return (Pt / Pd / Rh)",
    qbAccount: "Precious Metals Inventory",
    qbAccountType: "Other Current Asset",
    side: "Debit",
  },
  {
    id: 4,
    catSource: "Settlement — Refining / Treatment Charges",
    qbAccount: "Refining Expense",
    qbAccountType: "Expense",
    side: "Debit",
  },
  {
    id: 5,
    catSource: "Settlement — Net Settlement Amount",
    qbAccount: "Accounts Receivable — Refinery",
    qbAccountType: "Accounts Receivable",
    side: "Credit",
  },
  {
    id: 6,
    catSource: "Ounce — Metal Value (Pt / Pd / Rh)",
    qbAccount: "Inventory Valuation",
    qbAccountType: "Other Current Asset",
    side: "Debit",
  },
  {
    id: 7,
    catSource: "Ounce — Contra / COGS Offset",
    qbAccount: "Cost of Goods Sold",
    qbAccountType: "Cost of Goods Sold",
    side: "Credit",
  },
];

export const JOURNAL_SAMPLES = {
  costSheet: {
    id: "JE-CS-10482",
    source: "Cost Sheet",
    sourceRef: "Invoice #INV-33201 · Load #L-8841",
    date: "2026-10-13",
    memo: "Purchase recorded from Cost Sheet — Ceramic / Foil lots",
    customer: "Metro Auto Recycling",
    facility: "Dallas Yard",
    amount: 18450.0,
    lines: [
      {
        account: "Inventory Asset",
        description: "Converters purchased — Amount Paid",
        debit: 18450.0,
        credit: null,
      },
      {
        account: "Operating Bank Account",
        description: "Payment via Bank Transfer",
        debit: null,
        credit: 18450.0,
      },
    ],
  },
  settlement: {
    id: "JE-ST-22014",
    source: "Settlement",
    sourceRef: "Settlement #S-441 · Lot LOT-2291",
    date: "2026-10-12",
    memo: "Refinery settlement — metal return & charges",
    customer: "Heraeus Refining",
    facility: "Houston Facility",
    amount: 83413.0,
    lines: [
      {
        account: "Precious Metals Inventory",
        description: "Metal Return — Pt 12.4 oz @ $980",
        debit: 12152.0,
        credit: null,
      },
      {
        account: "Precious Metals Inventory",
        description: "Metal Return — Pd 48.2 oz @ $980",
        debit: 47236.0,
        credit: null,
      },
      {
        account: "Precious Metals Inventory",
        description: "Metal Return — Rh 4.1 oz @ $4,850",
        debit: 19885.0,
        credit: null,
      },
      {
        account: "Refining Expense",
        description: "Refining Charge + Treatment Charge",
        debit: 3250.0,
        credit: null,
      },
      {
        account: "Freight Expense",
        description: "Freight / Logistics",
        debit: 890.0,
        credit: null,
      },
      {
        account: "Accounts Receivable — Refinery",
        description: "Net Settlement Amount due",
        debit: null,
        credit: 83413.0,
      },
    ],
  },
  ounce: {
    id: "JE-OZ-9011",
    source: "Ounce Report",
    sourceRef: "Ounce Dashboard · Oct 1–14, 2026",
    date: "2026-10-14",
    memo: "Period ounce acquisition valuation — Ceramic / Diesel / After Market",
    customer: "—",
    facility: "All Facilities",
    amount: 94254.0,
    lines: [
      {
        account: "Inventory Valuation",
        description: "Pt ounces acquired — 22.8 oz",
        debit: 22344.0,
        credit: null,
      },
      {
        account: "Inventory Valuation",
        description: "Pd ounces acquired — 61.5 oz",
        debit: 60270.0,
        credit: null,
      },
      {
        account: "Inventory Valuation",
        description: "Rh ounces acquired — 2.4 oz",
        debit: 11640.0,
        credit: null,
      },
      {
        account: "Cost of Goods Sold",
        description: "Contra valuation entry",
        debit: null,
        credit: 94254.0,
      },
    ],
  },
};

export const SYNC_HISTORY = [
  {
    id: "SYNC-901",
    source: "Cost Sheet",
    sourceRef: "INV-33201",
    qbDoc: "Journal Entry JE-CS-10482",
    amount: 18450.0,
    status: "Synced",
    syncedAt: "2026-10-13 04:12 PM",
  },
  {
    id: "SYNC-902",
    source: "Settlement",
    sourceRef: "S-441",
    qbDoc: "Journal Entry JE-ST-22014",
    amount: 83413.0,
    status: "Synced",
    syncedAt: "2026-10-12 11:05 AM",
  },
  {
    id: "SYNC-903",
    source: "Ounce",
    sourceRef: "Oct 1–14",
    qbDoc: "Journal Entry JE-OZ-9011",
    amount: 94254.0,
    status: "Synced",
    syncedAt: "2026-10-14 09:42 AM",
  },
  {
    id: "SYNC-904",
    source: "Cost Sheet",
    sourceRef: "INV-33188",
    qbDoc: "—",
    amount: 9200.0,
    status: "Pending",
    syncedAt: "—",
  },
  {
    id: "SYNC-905",
    source: "Settlement",
    sourceRef: "S-438",
    qbDoc: "Journal Entry JE-ST-21990",
    amount: 67440.0,
    status: "Failed",
    syncedAt: "2026-10-11 02:18 PM",
  },
];

export const SOURCE_CARDS = [
  {
    key: "costSheet",
    title: "Cost Sheet",
    subtitle: "Buying cost / invoice payments",
    description:
      "When a finalized load is paid, CAT posts a balanced journal: Debit Inventory, Credit Cash/Bank.",
    trigger: "Cost Sheet row recorded / invoice paid",
  },
  {
    key: "settlement",
    title: "Settlement",
    subtitle: "Refinery settlement statements",
    description:
      "Metal returns, refining charges, and net settlement amount become debit/credit lines in QuickBooks.",
    trigger: "Settlement marked completed",
  },
  {
    key: "ounce",
    title: "Ounce Report",
    subtitle: "Pt / Pd / Rh ounce valuation",
    description:
      "Period ounce totals are valued and posted as inventory valuation journal entries.",
    trigger: "Ounce report period closed / sync run",
  },
];
